<template>
<div class="boxed-list">
  <ul>
    <li v-for="item in items">
      <h4>{{ item.title }}</h4>
      <div class="prop">
        <label>{{ labels.category }}</label>
        <span>{{ item.category }}</span>
      </div>
      <div class="prop">
        <label>{{ labels.email }}</label>
        <span><a :href="'mailto:'+item.email">{{ item.email }}</a></span>
      </div>
      <div class="prop">
        <label>{{ labels.website }}</label>
        <span><a :href="item.website">{{ item.website }}</a></span>
      </div>
      <a class="lnk-more" :href="item.link">{{ item.readmore }}</a>
      <a :href="item.link" class="box-link"></a>
    </li>
  </ul>
</div>
</template>
<script>
export default {
  props: ["items"],
  data: ()=>({
    labels: {
      sc: {category: "Категорија", email: "Е-пошта", website: "Веб сајт"},
      sr: {category: "Kategorija", email: "E-pošta", website: "Veb sajt"},
      en: {category: "Category", email: "E-Mail", website: "Website"},
    }[appLang],
  }),
  mounted() {
    scrollAnimations(this.$el.parentNode);
  },
}
</script>
